import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../hooks/useAuth";

const PLANES_VALIDOS = ["plus", "pro", "max"] as const;
type PlanValido = (typeof PLANES_VALIDOS)[number];

function esPlanValido(p: string | null): p is PlanValido {
  return !!p && (PLANES_VALIDOS as readonly string[]).includes(p);
}

export default function Checkout() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { token, isAuthenticated } = useAuth();
  const [error, setError] = useState<string | null>(null);

  const plan = searchParams.get("plan");

  useEffect(() => {
    if (!esPlanValido(plan)) {
      navigate("/#membresia", { replace: true });
      return;
    }

    if (!isAuthenticated) {
      navigate(`/registro?plan=${plan}`, { replace: true });
      return;
    }

    if (!token) return;

    api.crearSesionPago(token, plan).then((r) => {
      if (r.ok) {
        window.location.href = r.data.url;
      } else {
        setError(r.error.message || "No se pudo iniciar el pago. Intenta de nuevo.");
      }
    });
  }, [plan, isAuthenticated, token]);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)", fontFamily: "var(--font-body)", padding: 24 }}>
        <div className="card" style={{ maxWidth: 380, width: "100%", padding: 32, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
          <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 19, margin: "0 0 10px" }}>
            No pudimos iniciar el pago
          </h1>
          <p style={{ fontSize: 14, color: "var(--muted)", marginBottom: 20 }}>{error}</p>
          <Link to="/dashboard" className="btn btn-primary btn--full">Volver a mi espacio</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)", fontFamily: "var(--font-body)" }}>
      <div style={{ textAlign: "center" }}>
        <span className="spinner spinner--dark" />
        <p style={{ marginTop: 16, fontSize: 14, color: "var(--muted)" }}>Preparando tu checkout…</p>
      </div>
    </div>
  );
}
